import { app } from '../../../../app';
import { Controller } from './add-directory.controller';

app.component('companyDirectoryIntegrationAddDirectory', {
    bindings: {
        companyId: '<',
        directories: '<',
        directoryType: '<',
    },
    controller: Controller,
    templateUrl: require('./add-directory.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/directory-integration/add/add-directory.component.js